import Vue from 'vue'
import VueCookies from 'vue-cookies'
import user from './user'

Vue.use(VueCookies)

const api = {
  ...user
}

export default api
